<div class="loading-field" [ngClass]="{ 'anima-gradient': loading }"></div>